// Field definitions for Edit Info dialogs
export const EDIT_DIALOG_CONFIGS = {
  property: {
    title: 'Edit Property Information',
    maxWidth: 'sm:max-w-[500px]',
    fields: [
      { name: 'property_address', label: 'Property Address', type: 'text', placeholder: '123 Main St, City, State ZIP' },
      { 
        name: 'property_type', 
        label: 'Property Type', 
        type: 'select',
        options: [
          { value: 'commercial', label: 'Commercial' },
          { value: 'residential', label: 'Residential' }
        ]
      },
      { name: 'property_year_built', label: 'Year Built', type: 'number', placeholder: '1985', min: 1800, max: 2030, grid: 2 },
      { name: 'property_year_acquired', label: 'Year Acquired', type: 'number', placeholder: '2020', min: 1800, max: 2030, grid: 2 },
      { name: 'property_size_sqft', label: 'Size (sq/ft)', type: 'number', placeholder: '2,500', min: 0, step: 0.01, grid: 2 },
      { name: 'property_acreage', label: 'Acreage', type: 'number', placeholder: '0.5', min: 0, step: 0.001, grid: 2 },
      { name: 'property_description', label: 'Property Description', type: 'textarea', placeholder: '3 bed/2 bath single family home...', rows: 3 }
    ]
  },
  accountant: {
    title: 'Edit Accountant Information',
    fields: [
      { name: 'accountant_name', label: 'Accountant Name', type: 'text', placeholder: 'John Smith, CPA' },
      { name: 'accountant_firm', label: 'Firm Name', type: 'text', placeholder: 'Smith & Associates' },
      { name: 'accountant_address', label: 'Address', type: 'text', placeholder: '123 Main St, City, State ZIP' },
      { name: 'accountant_email', label: 'Email', type: 'email', placeholder: 'accountant@example.com', grid: 2 },
      { name: 'accountant_phone', label: 'Phone', type: 'text', placeholder: '(555) 123-4567', grid: 2 }
    ]
  },
  bank: {
    title: 'Edit Bank Information',
    maxWidth: 'sm:max-w-[500px]',
    scrollable: true,
    fields: [
      { name: 'bank_name', label: 'Bank Name', type: 'text', placeholder: 'First National Bank' },
      { name: 'bank_address', label: 'Bank Address', type: 'text', placeholder: '123 Main St, City, State ZIP' },
      { name: 'bank_account_name', label: 'Account Name', type: 'text', placeholder: 'LLC Operating Account' },
      { name: 'bank_account_number', label: 'Account Number', type: 'text', placeholder: '123456789' },
      { name: 'bank_routing_inbound', label: 'Routing (Inbound)', type: 'text', placeholder: '021000021', grid: 2 },
      { name: 'bank_routing_outbound', label: 'Routing (Outbound)', type: 'text', placeholder: '021000022', grid: 2 },
      { type: 'divider', label: 'Bank Contact' },
      { name: 'bank_officer', label: 'Bank Officer', type: 'text', placeholder: 'John Smith' },
      { name: 'bank_email', label: 'Email', type: 'email', placeholder: 'banker@bank.com', grid: 2 },
      { name: 'bank_phone', label: 'Phone', type: 'text', placeholder: '(555) 123-4567', grid: 2 }
    ]
  },
  lender: {
    title: 'Edit Lender Information',
    scrollable: true,
    fields: [
      { name: 'lender_name', label: 'Lender Name', type: 'text', placeholder: 'ABC Lending Corp' },
      { name: 'lender_address', label: 'Lender Address', type: 'text', placeholder: '123 Main St, City, State ZIP' },
      { name: 'lender_account_number', label: 'Loan Number', type: 'text', placeholder: 'LOAN-12345' },
      { type: 'divider', label: 'Loan Details' },
      { name: 'lender_original_amount', label: 'Original Amount', type: 'number', placeholder: '500000', min: 0, step: 0.01, grid: 2 },
      { name: 'lender_interest_rate', label: 'Interest Rate (%)', type: 'number', placeholder: '5.5', min: 0, max: 100, step: 0.001, grid: 2 },
      { name: 'lender_maturity_date', label: 'Maturity Date', type: 'date' },
      { type: 'divider', label: 'Lender Contact' },
      { name: 'lender_contact_name', label: 'Contact Name', type: 'text', placeholder: 'Jane Doe' },
      { name: 'lender_email', label: 'Email', type: 'email', placeholder: 'loans@lender.com', grid: 2 },
      { name: 'lender_phone', label: 'Phone', type: 'text', placeholder: '(555) 123-4567', grid: 2 }
    ]
  },
  tenant: {
    title: 'Edit Tenant Information',
    fields: [
      { name: 'tenant_name', label: 'Tenant Name', type: 'text', placeholder: 'ABC Corporation' },
      { name: 'lease_sqft', label: 'Leased Sq/Ft', type: 'number', placeholder: '2500', min: 0, step: 0.01, grid: 2 },
      { name: 'lease_rate_per_sqft', label: 'Rate per Sq/Ft ($)', type: 'number', placeholder: '12.50', min: 0, step: 0.01, grid: 2 },
      { name: 'lease_start_date', label: 'Lease Start', type: 'date', grid: 2 },
      { name: 'lease_expiration_date', label: 'Lease Expiration', type: 'date', grid: 2 }
    ]
  }
};
